{
  "REPORT": {
    "HEADER": "Razgovori",
    "LOADING_CHART": "Učitavanje podataka grafikona...",
    "NO_ENOUGH_DATA": "Nismo primili dovoljno podataka da bi smo generisali izveštaj, Molim vas pokušajte ponovo.",
    "DOWNLOAD_CONVERSATION_REPORTS": "Download conversation reports",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Razgovori",
        "DESC": "( Ukupno )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Dolazne poruke",
        "DESC": "( Ukupno )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odlazne poruke",
        "DESC": "( Ukupno )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Vreme prvog odgovora",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme prvog odgovora je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Vreme rešavanja",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme rešenja je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Broj rešenih",
        "DESC": "( Ukupno )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Broj rešenih",
        "DESC": "( Ukupno )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( Ukupno )"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "LAST_7_DAYS": "Poslednjih 7 dana",
      "LAST_14_DAYS": "Poslednjih 14 dana",
      "LAST_30_DAYS": "Poslednjih 30 dana",
      "THIS_MONTH": "This month",
      "LAST_MONTH": "Last month",
      "LAST_3_MONTHS": "Poslednja 3 meseca",
      "LAST_6_MONTHS": "Poslednjih 6 meseci",
      "LAST_YEAR": "Poslednja godina",
      "CUSTOM_DATE_RANGE": "Prilagođen opseg vremena"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Primeni",
      "PLACEHOLDER": "Izaberite opseg vremena"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Vrednost za grupisanje",
    "DURATION_FILTER_LABEL": "Trajanje",
    "GROUPING_OPTIONS": {
      "DAY": "Dan",
      "WEEK": "Nedelja",
      "MONTH": "Mesec",
      "YEAR": "Godina"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dan"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dan"
      },
      {
        "id": 2,
        "groupBy": "Nedelja"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dan"
      },
      {
        "id": 2,
        "groupBy": "Nedelja"
      },
      {
        "id": 3,
        "groupBy": "Mesec"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dan"
      },
      {
        "id": 2,
        "groupBy": "Nedelja"
      },
      {
        "id": 3,
        "groupBy": "Mesec"
      }
    ],
    "BUSINESS_HOURS": "Radno vreme",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Ništa nije pronađeno"
    },
    "DRILLDOWN": {
      "TITLE": "{metric} details",
      "RESULT_COUNT_CONVERSATION": "{count} conversation | {count} conversations",
      "RESULT_COUNT_MESSAGE": "{count} message | {count} messages",
      "EMPTY": "No records found for this bar.",
      "ERROR": "Could not load records. Please try again.",
      "ADMIN_ONLY": "Only administrators can drill down into report records.",
      "LOAD_MORE": "Load more",
      "CLOSE": "Close details",
      "PREVIOUS_BUCKET": "Previous bar",
      "NEXT_BUCKET": "Next bar",
      "UNKNOWN_CONTACT": "Unknown contact",
      "UNKNOWN_INBOX": "Unknown inbox",
      "UNASSIGNED_AGENT": "Nedodeljen",
      "NO_MESSAGE_CONTENT": "No message content",
      "MESSAGE_CREATED_AT": "Message created at {time}",
      "EVENT_OCCURRED_AT": "Event occurred at {time}",
      "INCOMING_MESSAGE": "Incoming message",
      "OUTGOING_MESSAGE": "Outgoing message"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Pregled agenata",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent's name to learn more.",
    "LOADING_CHART": "Učitavanje podataka grafikona...",
    "NO_ENOUGH_DATA": "Nismo primili dovoljno podataka da bi smo generisali izveštaj, Molim vas pokušajte ponovo.",
    "DOWNLOAD_AGENT_REPORTS": "Preuzmi izveštaj o agentima",
    "FILTER_DROPDOWN_LABEL": "Izaberi agenta",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "AGENTS": "Traži agente"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Razgovori",
        "DESC": "( Ukupno )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Dolazne poruke",
        "DESC": "( Ukupno )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odlazne poruke",
        "DESC": "( Ukupno )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Vreme prvog odgovora",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme prvog odgovora je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Vreme rešavanja",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme rešenja je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Broj rešenih",
        "DESC": "( Ukupno )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Poslednjih 7 dana"
      },
      {
        "id": 1,
        "name": "Poslednjih 30 dana"
      },
      {
        "id": 2,
        "name": "Poslednja 3 meseca"
      },
      {
        "id": 3,
        "name": "Poslednjih 6 meseci"
      },
      {
        "id": 4,
        "name": "Poslednja godina"
      },
      {
        "id": 5,
        "name": "Prilagođen opseg vremena"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Primeni",
      "PLACEHOLDER": "Izaberite opseg vremena"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Pregled oznaka",
    "DESCRIPTION": "Track label performance with key metrics including conversations, response times, resolution times, and resolved cases. Click a label name for detailed insights.",
    "LOADING_CHART": "Učitavanje podataka grafikona...",
    "NO_ENOUGH_DATA": "Nismo primili dovoljno podataka da bi smo generisali izveštaj, Molim vas pokušajte ponovo.",
    "DOWNLOAD_LABEL_REPORTS": "Preuzmi izveštaj o oznakama",
    "FILTER_DROPDOWN_LABEL": "Izaberi oznaku",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "LABELS": "Pretraži oznake"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Razgovori",
        "DESC": "( Ukupno )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Dolazne poruke",
        "DESC": "( Ukupno )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odlazne poruke",
        "DESC": "( Ukupno )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Vreme prvog odgovora",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme prvog odgovora je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Vreme rešavanja",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme rešenja je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Broj rešenih",
        "DESC": "( Ukupno )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Poslednjih 7 dana"
      },
      {
        "id": 1,
        "name": "Poslednjih 30 dana"
      },
      {
        "id": 2,
        "name": "Poslednja 3 meseca"
      },
      {
        "id": 3,
        "name": "Poslednjih 6 meseci"
      },
      {
        "id": 4,
        "name": "Poslednja godina"
      },
      {
        "id": 5,
        "name": "Prilagođen opseg vremena"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Primeni",
      "PLACEHOLDER": "Izaberite opseg vremena"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Pregled prijemnih sandučića",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Učitavanje podataka grafikona...",
    "NO_ENOUGH_DATA": "Nismo primili dovoljno podataka da bi smo generisali izveštaj, Molim vas pokušajte ponovo.",
    "DOWNLOAD_INBOX_REPORTS": "Preuzmi izveštaj o prijemnim sandučićima",
    "FILTER_DROPDOWN_LABEL": "Izaberi prijemno sanduče",
    "ALL_INBOXES": "All Inboxes",
    "SEARCH_INBOX": "Search Inbox",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "INBOXES": "Search inboxes"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Razgovori",
        "DESC": "( Ukupno )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Dolazne poruke",
        "DESC": "( Ukupno )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odlazne poruke",
        "DESC": "( Ukupno )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Vreme prvog odgovora",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme prvog odgovora je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Vreme rešavanja",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme rešenja je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Broj rešenih",
        "DESC": "( Ukupno )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Poslednjih 7 dana"
      },
      {
        "id": 1,
        "name": "Poslednjih 30 dana"
      },
      {
        "id": 2,
        "name": "Poslednja 3 meseca"
      },
      {
        "id": 3,
        "name": "Poslednjih 6 meseci"
      },
      {
        "id": 4,
        "name": "Poslednja godina"
      },
      {
        "id": 5,
        "name": "Prilagođen opseg vremena"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Primeni",
      "PLACEHOLDER": "Izaberite opseg vremena"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Pregled tima",
    "DESCRIPTION": "Get a snapshot of your team's performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Učitavanje podataka grafikona...",
    "NO_ENOUGH_DATA": "Nismo primili dovoljno podataka da bi smo generisali izveštaj, Molim vas pokušajte ponovo.",
    "DOWNLOAD_TEAM_REPORTS": "Preuzmi izveštaj o timu",
    "FILTER_DROPDOWN_LABEL": "Izaberi tim",
    "FILTERS": {
      "ADD_FILTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "NO_FILTER": "No filters available",
      "INPUT_PLACEHOLDER": {
        "TEAMS": "Traži tim"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Razgovori",
        "DESC": "( Ukupno )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Dolazne poruke",
        "DESC": "( Ukupno )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odlazne poruke",
        "DESC": "( Ukupno )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Vreme prvog odgovora",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme prvog odgovora je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Vreme rešavanja",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme rešenja je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Broj rešenih",
        "DESC": "( Ukupno )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Poslednjih 7 dana"
      },
      {
        "id": 1,
        "name": "Poslednjih 30 dana"
      },
      {
        "id": 2,
        "name": "Poslednja 3 meseca"
      },
      {
        "id": 3,
        "name": "Poslednjih 6 meseci"
      },
      {
        "id": 4,
        "name": "Poslednja godina"
      },
      {
        "id": 5,
        "name": "Prilagođen opseg vremena"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Primeni",
      "PLACEHOLDER": "Izaberite opseg vremena"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "Izveštaji zadovoljstva korisnika",
    "NO_RECORDS": "No responses yet",
    "NO_RECORDS_DESCRIPTION": "CSAT survey responses will appear here once customers start providing feedback.",
    "DOWNLOAD": "Preuzmite izveštaje o zadovoljstvu korisnika",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "ADD_FILTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "NO_FILTER": "No filters available",
      "INPUT_PLACEHOLDER": {
        "AGENTS": "Traži agente",
        "INBOXES": "Search inboxes",
        "TEAMS": "Traži tim",
        "RATINGS": "Search ratings"
      },
      "AGENTS": {
        "LABEL": "Agent"
      },
      "INBOXES": {
        "LABEL": "Prijemno sanduče"
      },
      "TEAMS": {
        "LABEL": "Tim"
      },
      "RATINGS": {
        "LABEL": "Ocena"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Kontakt",
        "AGENT_NAME": "Agent",
        "RATING": "Ocena",
        "FEEDBACK_TEXT": "Komentar povratne informacije",
        "CONVERSATION": "Razgovor",
        "CUSTOMER": "Customer",
        "RESPONSE": "Response",
        "HANDLED_BY": "Handled by"
      },
      "UNKNOWN_CUSTOMER": "Unknown customer"
    },
    "NO_AGENT": "No assigned agent",
    "NO_FEEDBACK": "No feedback provided",
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Ukupno odgovora",
        "TOOLTIP": "Ukupan broj prikupljenih odgovora"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Ocena zadovoljstva",
        "TOOLTIP": "Ukupan broj pozitivnih odgovora / Ukupan broj odgovora * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Procenat odgovora",
        "TOOLTIP": "Ukupan broj odgovora / Ukupan broj poruka o zadovoljstvu korisnika * 100"
      },
      "RATING_DISTRIBUTION": "Rating distribution"
    },
    "REVIEW_NOTES": {
      "TITLE": "Review notes",
      "PLACEHOLDER": "Add review notes about this rating...",
      "SAVE": "Save",
      "CANCEL": "Otkaži",
      "SAVING": "Saving...",
      "SAVED": "Notes saved successfully",
      "SAVE_ERROR": "Failed to save notes",
      "UPDATED_BY": "Updated by {name} {time}",
      "UPDATED_BY_LABEL": "Updated by",
      "PAYWALL": {
        "TITLE": "Upgrade to add review notes",
        "AVAILABLE_ON": "The review notes feature is only available in the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Add internal context to every CSAT response with review notes. Capture what really happened, spot patterns faster, and make better decisions from your feedback.",
        "UPGRADE_NOW": "Upgrade now",
        "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Pregled",
    "LIVE": "Uživo",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Otvoreni razgovori",
      "LOADING_MESSAGE": "Učitavanje metrike razgovora...",
      "OPEN": "Otvoreni",
      "UNATTENDED": "Nedodeljeni",
      "UNASSIGNED": "Nedodeljen",
      "PENDING": "Nerešen"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "RESOLUTION_HEATMAP": {
      "HEADER": "Resolutions",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Razgovori prema agentima",
      "LOADING_MESSAGE": "Učitavanje metrike agenata...",
      "NO_AGENTS": "Nema razgovora po agentima",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Otvoreni",
        "UNATTENDED": "Nedodeljeni",
        "STATUS": "Status"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Tim",
        "OPEN": "Otvoreni",
        "UNATTENDED": "Nedodeljeni",
        "STATUS": "Status"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Status agenta",
      "ONLINE": "Dostupan",
      "BUSY": "Zauzet",
      "OFFLINE": "Nedostupan"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Ništa nije pronađeno",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Naziv agenta",
        "INBOXES": "Naziv prijemnog sandučeta",
        "LABELS": "Naziv oznake",
        "TEAMS": "Naziv tima"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Prijemno sanduče",
      "AGENTS": "Agent",
      "LABELS": "Oznaka",
      "TEAMS": "Tim"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Razgovor",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "INBOX": "Prijemno sanduče",
    "AGENT": "Agent",
    "TEAM": "Tim",
    "LABEL": "Oznaka",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Broj rešenih",
    "CONVERSATIONS": "Broj razgovora"
  }
}
